module.exports = __webpack_public_path__ + "img/task-alt.e9d19cfe.svg";